export default "__VITE_ASSET__ad1f40e2__"